import { Div, Text } from "@vkontakte/vkui";
import styles from "./StatusLine.style";
import doneImg from "../../../img/done.svg";
import rejectImg from "../../../img/reject.svg";
import waitImg from "../../../img/wait.svg";
import React from "react";

const StatusLine = ({ title, status, date, center }) => {
  let image;
  if (status.localeCompare("reject") === 0) {
    image = rejectImg;
  } else if (
    status.localeCompare("executed") === 0 ||
    status.localeCompare("done") === 0
  ) {
    image = doneImg;
  } else {
    image = waitImg;
  }
  let style;
  if (center) {
    style = {
      ...styles.flexContainer,
      ...styles.center,
    };
  } else {
    style = styles.flexContainer;
  }

  const isReject = status === "rejected"
  return (
    <Div style={{...style, justifyContent: isReject ? "flex-start" : style.justifyContent}}>
      {isReject && (
        <img src={image} style={{...styles.statusImg, marginRight: "4px"}} alt="" />

      )}
      {!isReject && (<Text weight="regular" style={styles.dateText}>
        {date}
      </Text>)}
      <Text weight="regular" style={{...styles.statusText, color: isReject ? "#FF7C49" : undefined
      }}>
        {title}
      </Text>
      {!isReject && (
        <img src={image} style={styles.statusImg} alt="" />
      )}
    </Div>
  );
};

export default StatusLine;
